import styled from "styled-components";

export const PaypalContainer = styled.div`
    
    height: 70vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`